var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonS3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_6737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03138 9.33203L4.58008 11.0289V40.8096L8.03138 42.4965L8.05213 42.472V9.35539L8.03138 9.33203Z",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.502 38.174L8.03125 42.4965V9.33203L26.502 13.5603V38.174Z",
    fill: "#E05243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 31.4075L25.9987 32.388L26.0479 32.2765L26.092 19.6466L25.9987 19.5479L18.1641 20.5142V31.4075",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.999 38.2225L43.9669 42.5057L43.9952 42.4614L43.9947 9.36164L43.9662 9.33203L25.999 13.6088V38.2225",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8359 31.4075L25.999 32.388V19.5479L33.8359 20.5142V31.4075Z",
    fill: "#E05243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8357 15.2458L25.9988 16.6499L18.1641 15.2458L25.9889 13.2295L33.8357 15.2458Z",
    fill: "#5E1F18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8356 36.6614L25.9988 35.248L18.1641 36.6614L25.9892 38.8088L33.8356 36.6614Z",
    fill: "#F2B0A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 15.2457L25.9988 13.3397L26.0622 13.3204V0.551494L25.9988 0.5L18.1641 4.35182V15.2457Z",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8359 15.2457L25.999 13.3397V0.5L33.8359 4.35182V15.2457Z",
    fill: "#E05243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 51.4054L18.1641 47.5549V36.6611L25.9996 38.5666L26.1149 38.6954L26.0836 51.1831L25.9996 51.4054Z",
    fill: "#8C3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.999 51.4054L33.8352 47.5549V36.6611L25.999 38.5666V51.4054",
    fill: "#E05243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9668 9.33203L47.4196 11.0288V40.8095L43.9668 42.5057V9.33203Z",
    fill: "#E05243"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_6737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3);
export default __webpack_public_path__ + "static/media/amazon-s3.189857eca5ffb89752ca2f04473292e5.svg";
export { ForwardRef as ReactComponent };